/**
 * Created by Christof Sander on 22.06.2016.
 */

const CONSTANTS = require('../../lib/constants');
const utils = require('../../lib/utils');

module.exports = {
	config: {
		isContainerComponent: true,
		decisionMaker: true,
		focusAble: true,
		focusPriority: 1000,
		preventKeyDownControls: false,
		delayDecision: 0, // delay in [ms] to wait after a button click has happened
		preventUserInteraction: false // render modal without width to prevent user interaction as well as interference with other gui elements.
	},

	model: {
		states: {
			active: true
		},
		title: 'BASE MODAL',
		offsetLevel: 0
	},

	actions: {
		addButton: {
			type: CONSTANTS.COMPONENT.ACTION.TYPE.LOAD,
			source: {
				load: {}
			},
			target: {
				element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SUB_SELECTOR,
				position: CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.APPEND,
				selector: 'section.footer'
			}
		},
		loadContent: {
			type: CONSTANTS.COMPONENT.ACTION.TYPE.LOAD,
			source: {
				load: {}
			},
			target: {
				element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SUB_SELECTOR,
				position: CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.HTML,
				selector: 'section.body'
			}
		}
	},

	events: {
		/**
		 * this function handles the Escape and Enter key-down-events
		 */
		keyboard: {
			type: 'keydown',
			action: function(event){
				var self = event.data.component;
				var keyCode = utils.keyboard.getKeyCode(event);

				if(self.config.preventKeyDownControls && (keyCode === 'enter' || keyCode === 'esc')) {
					event.stopImmediatePropagation();
					event.stopPropagation();
					event.preventDefault();
				} else if($(event.target).closest('button, textarea').length > 0 && keyCode === 'enter') {
					event.stopImmediatePropagation();
				} else {
					var positive = false;
					switch(keyCode){
						case 'enter':
							positive = true;
						case 'esc':
							var $useButton;
							if(positive){
								if(($useButton = event.data.component.$.find('section.footer button.positive:visible')).length == 1){
									event.stopImmediatePropagation();
									$useButton.click();
									return false;
								}
							}
							else {
								if(
									($useButton = event.data.component.$.find('section.footer button.negative:visible')).length == 1
									||
									($useButton = event.data.component.$.find('> .background')).length == 1
								){
									event.stopImmediatePropagation();
									$useButton.click();
								}
							}
							break;
					}
				}
			}
		},

		decision: {
			type: 'click',
			selector: '.background, section.header button.close, section.footer button',
			action: function (event) {
				var self = event.data.component;

				if(self.config.delayDecision){
					window.setTimeout(() => {
						event.preventDefault();
						event.stopImmediatePropagation();
						self.processDecisionByButton(event.currentTarget);
					}, self.config.delayDecision)
				} else {
					event.preventDefault();
					event.stopImmediatePropagation();
					self.processDecisionByButton(event.currentTarget);
				}
			}
		}
	},

	methods: {
		toggle: function(){
			if(this.model.states.active)    this.hide();
			else                            this.show();
		},

		show: function(handleLoadingState){
			this.model.states.active = true;
			this.$.addClass('active');
			if(handleLoadingState !== false){
				window.setTimeout(function(component){
					component.$.removeClass('invisible');
				}, 50, this)
			}
		},

		hide: function(){
			// TODO: test and cleanup if unconditional destroy has no side-effects
			this.destroy();
			// if(!this.isParentActionStatic){
			// 	this.destroy();
			// }
			// else {
			// 	this.model.states.active = false;
			// 	this.$.removeClass('active');
			// 	this.$.addClass('invisible');
			// }
		},

		processDecision: function(decisionTriggerComponent, decisionType, mode){
			if(decisionType){
				var triggerFound 		= false;
				var decisionOptions 	= this.config.decisionOptions || {};
				decisionOptions.mode 	= mode;

				var decisionData = {
					decisionType: 				decisionType,
					decisionComponent: 			this,
					decisionOptions: 			decisionOptions,
					decisionTriggerComponent: 	decisionTriggerComponent
				};

				if(this.config.decisionMaker){
					this.parent(function(parentComponent){
						if(utils.isFunction(parentComponent.hooks.onDecision)){
							triggerFound = true;
							parentComponent.trigger('onDecision', decisionData);
						}
					});
				}

				if(!triggerFound){
					this.trigger('onDecision', decisionData);
				}
			}
		},

		processDecisionByButton: function(domButton, decisionTriggerComponent){
			if(domButton){
				this.processDecision(decisionTriggerComponent, domButton.dataset.fieldType, domButton.dataset.buttonMode);
			}
		},

		decide: function(positive, decisionComponent){
			var $useButton;
			if(positive || positive === undefined){
				if(($useButton = this.$.find('section.footer button.positive:visible')).length == 1){
					this.processDecisionByButton($useButton[0], decisionComponent);
				}
			} else if(
				($useButton = this.$.find('section.footer button.negative:visible')).length == 1
				||
				($useButton = this.$.find('> .background')).length == 1
			){
				this.processDecisionByButton($useButton[0], decisionComponent);
			}
		},

		setOffsetLevel: function(offsetLevel = 0){
			this.model.offsetLevel = offsetLevel;
			if(this.$.length > 0){
				this.$[0].style.setProperty('--offset-level', offsetLevel);
			}
		}
	},

	hooks: {
		include: function($element, options){
			$element.find('section.footer').append(
				this.include(
					'../form/elements/buttons',
					{
						formMapping: {
							buttons: this.model.buttons
						}
					}
				)
			);
		},

		attach: function($element, options){
			var self = this;

			if(self.model.states.active || (!!options.refresh && !options.autoRefresh)){
				self.show(false);
			}
			else {
				self.hide();
			}

			// load content
			if(!options.refresh){
				self.performAction('loadContent').then(function(context){
					window.setTimeout(function(component){
						component.$.removeClass('invisible');
						self.triggerFind('modalAttached');
					}, 50, context.component)
				}).fail(function(errorContext){
					self.hide();
				});
			}
			else {
				window.setTimeout(function(component){
					component.$.removeClass('invisible');
					self.triggerFind('modalAttached');
				}, 50, self)
			}
		},

		// fallback trigger
		onDecision: function($element, options){
			var triggerFound = false;

			if(
				(
					options.decisionType === 'decisionComponent'
					||
					(
						options.decisionType === 'cancel'
						&&
						this.config.decisionComponentHandlesCancel
					)

				)
				&& options.decisionComponent
			){
				if(options.decisionComponent.componentIndex != this.componentIndex){
					options.decisionComponent.trigger('onDecision', options);
					triggerFound = true;
				}
				else if(this.triggerFind('onDecision', options)){
					triggerFound = true;
				}
			}
			if(!triggerFound){
				if(this.config.decisionMaker){
					this.parent(function(parentComponent){
						if(utils.isFunction(parentComponent.hooks.onDecision)){
							triggerFound = true;
							parentComponent.trigger('onDecision', options);
						}
					});
				}

				if(!triggerFound){
					if(options.decisionType === 'cancel' || options.decisionType === 'close' || options.decisionType === 'done'){
						this.destroy();
					}
				}
			}
		}
	},
};
